import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;
  background-color: ${(p) => p.theme.background.primary};
  height: 100%;
`;
